import { loginAPI } from "../../../apis/LoginAPI.jsx";

export default class TwoStepVerificationService {
  confirmPhone(token, setState) {
    loginAPI
      .confirmPhone(token)
      .then((response) => {
        console.log("confirmPhone response", response);
        if (response.status === 200) {
          //Success
          var mySubString = response.data.payload.substring(
            response.data.payload.indexOf("[") + 1,
            response.data.payload.lastIndexOf("]]")
          );

          console.log(
            "setting state",
            mySubString.slice(mySubString.length - 3, mySubString.length)
          );
          setState({
            message:
              "xxx-xxx-" +
              mySubString.slice(mySubString.length - 3, mySubString.length),
            loadingPhone: false,
          });
        } else {
          //Failure
        }
      })
      .catch((error) => {
        //Failure
        console.log(error);
      });
  }

  validatePhone(token, code, setState, setMessages, getClientConfig) {
    loginAPI
      .validatePhone(token, code)
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          //Success
          getClientConfig();
          setState({
            loadingSent: false,
            stage: 2,
          });
        } else {
          //Failure
          setMessages("verify-phone-error-validate-phone");
          setState({
            invalidCode: true,
            loadingSent: false,
          });
        }
      })
      .catch((error) => {
        //Failure
        console.log(error);
        setMessages("verify-phone-error-validate-phone");
        setState({
          invalidCode: true,
          loadingSent: false,
        });
      });
  }
}
